import Vue         from 'vue';
import App         from './App.vue';
import VueRouter   from 'vue-router';
import routes      from './routes';
import VCalendar   from 'v-calendar';
import VueMaterial from 'vue-material';

import 'vue-material/dist/vue-material.min.css';

Vue.config.productionTip = false;

Vue.use(VCalendar, {
    formats: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
        dayPopover: 'L',
    }
});

Vue.use(VueMaterial);
Vue.use(VueRouter);


const router = new VueRouter({routes, base: '/PickupCalendar/'});
new Vue({
    router, render: h => h(App)
}).$mount('#app');